<template>
  <div class="home">
    <v-card>
    <v-card-title>
     Firebase
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="allUsers"
      sort-by="createdAt"
      class="elevation-1"
      :custom-sort="customSort"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>Users Lists</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                New User
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-text-field
                        v-model="editedItem.name"
                        label="Dessert name"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-text-field
                        v-model="editedItem.calories"
                        label="Calories"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-text-field
                        v-model="editedItem.fat"
                        label="Fat (g)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-text-field
                        v-model="editedItem.carbs"
                        label="Carbs (g)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-text-field
                        v-model="editedItem.protein"
                        label="Protein (g)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.duid="{ item }">
        <span>{{ item.duid }}</span>
        <v-icon
          small
          @click.stop="copyToClipboard(item.duid)"
        >
          mdi-content-copy
        </v-icon>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
  </div>
</template>
<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      search: '',
      headers: [
        { text: 'First Name', value: 'firstname', align: 'start', },
        { text: 'Last Name', value: 'lastname' },
        { text: 'Email', value: 'useremail' },
        { text: 'DUID', value: 'duid' },
        { text: 'Created At', value: 'createdAt', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
     ],
      
      users: [],
      editedIndex: -1,
      editedItem: {
        firstname: '',
        lastname: '',
        useremail: '',
      },
      defaultItem: {
        firstname: '',
        lastname: '',
        useremail: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      usersperson() {
        if (this.$store.getters.factsuser.USER_DEFAULT_SMAN_DOCNO) {
          return this.$store.getters.factsuser.USER_DEFAULT_SMAN_DOCNO;
        } else {
          return "";
        }
      },
      allUsers(){
        return this.$store.getters.allUsers
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    mounted() {
      this.users;
      // console.log(this.allUsers);
    },
    created () {
      this.initialize()
      this.$store.dispatch("getSalesPersons", { smandocno: this.usersperson })
      this.$store.dispatch("getallUsers")
    },

    methods: {
      initialize() {
        this.users = this.allUsers.map(user => ({
          ...user,
            // Assuming user.createdAt is a timestamp object with seconds
            createdAt: this.formatDate(user.createdAt),
        }));
      },

      editItem (item) {
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.users.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.users[this.editedIndex], this.editedItem)
        } else {
          this.users.push(this.editedItem)
        }
        this.close()
      },
      formatDate(timestamp) {
        const date = new Date(timestamp.seconds * 1000); // Convert to milliseconds
        return date.toLocaleDateString("en-US"); // Format as you like
      },
      customSort(items, sortBy, sortDesc) {
        // Custom sorting logic here
        // items: array of table items
        // sortBy: string, key to sort by
        // sortDesc: boolean, true if descending, false if ascending
        return items.sort((a, b) => {
          const sortA = a[sortBy];
          const sortB = b[sortBy];
          if (sortDesc) {
            return (sortA < sortB) ? 1 : -1;
          } else {
            return (sortA > sortB) ? 1 : -1;
          }
        });
      },
      async copyToClipboard(duid) {
        try {
            await this.$clipboard(duid);
            this.$toast.success('duid copied!');
        } catch (error) {
            this.$toast.error('Failed to copy text');
        }
      },
    },
  }
</script>